import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const isMobile = useIsMobile();

  // Скрываем Footer полностью на мобильных устройствах
  if (isMobile) {
    return null;
  }

  return (
    <footer className="mt-auto bg-muted border-t py-3">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-2 text-xs text-muted-foreground">
          {/* Информация о владельце */}
          <div className="text-center lg:text-left">
            <p>{t('common.owner_name')}</p>
            <p>
              {t('common.inn')}: 272109048195 |{" "}
              <a href="mailto:support@voice2doc.com" className="hover:text-brand-500">
                support@voice2doc.com
              </a>
            </p>
          </div>

          {/* Ссылки на документы */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            <a
              href="https://voice2doc.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-500"
            >
              {t('common.terms_of_use')}
            </a>
            <a
              href="https://voice2doc.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-500"
            >
              {t('common.privacy_policy')}
            </a>
            <a
              href="https://voice2doc.com/consent"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-500"
            >
              {t('common.consent_processing')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
